import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultDashboardRowsState, DashboardRowsState } from "../state/stateItems";
import { TDashboardRowItem } from "@/data/types";
import { getAllDashboardRowsAsync, getDashboardRowByIdAsync } from "../actions";

const handleGetAllDashboardRowsAsync = (
  state: DashboardRowsState,
  action: PayloadAction<{ items: TDashboardRowItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetDashboardRowByIdAsync = (
  state: DashboardRowsState,
  action: PayloadAction<TDashboardRowItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const dashboardRow = action.payload;

  state.currentDashboardRow = dashboardRow;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<DashboardRowsState>) => {
  builder.addCase(getAllDashboardRowsAsync.fulfilled.type, handleGetAllDashboardRowsAsync);
  builder.addCase(getDashboardRowByIdAsync.fulfilled.type, handleGetDashboardRowByIdAsync);
};

export default createReducer(DefaultDashboardRowsState, reducerBuilder);